import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-day-of-week-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(DayOfWeekMultiSelectSearchControlComponent)
    ]
})
export class DayOfWeekMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.common.dayOfWeek.monday", value: "1"},
            {label: "wbo.common.dayOfWeek.tuesday", value: "2"},
            {label: "wbo.common.dayOfWeek.wednesday", value: "3"},
            {label: "wbo.common.dayOfWeek.thursday", value: "4"},
            {label: "wbo.common.dayOfWeek.friday", value: "5"},
            {label: "wbo.common.dayOfWeek.saturday", value: "6"},
            {label: "wbo.common.dayOfWeek.sunday", value: "7"}
        ]);
    }
}
